"use client";

import BlogItem from "@/app/components/blog-item";
import Pagination from "@/app/components/pagination";
import React from "react";
import { usePathname, useSearchParams, useRouter } from "next/navigation";

interface BlogContainerProps {
    data: Array<{
        id: string;
        minRead: string;
        title: string;
        image: {
            url: string;
        };
        imageAlt?: string;
        metaData: {
            metaTitle: string;
            slug: string;
        }
    }>;
    pagination: {
        page: number;
        pageSize: number;
        pageCount: number;
        total: number;
    };
    currentPage: number;
}

const BlogContainer: React.FC<BlogContainerProps> = ({ data, pagination, currentPage }) => {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const router = useRouter();
    const isEn = pathname.startsWith("/en");

    const handlePageChange = (page: number) => {
        const params = new URLSearchParams(searchParams);
        params.set('page', page.toString());
        router.push(`${pathname}?${params.toString()}`);
    };
    
    return (
        <section className="mt-[42px] mb-[64px]">
            <div className="container">
                <div className="grid grid-cols-3 gap-x-[120px] gap-y-[40px] max-[1350px]:gap-x-[40px] max-[992px]:grid-cols-2 max-[992px]:grid-rows-3 max-[767px]:grid-cols-1 max-[767px]:grid-rows-6 max-[767px]:gap-y-[24px]">
                    {data.map((item) => {
                        const meta = item?.metaData;
                        return (
                            <BlogItem
                                key={item.id}
                                minRead={item.minRead}
                                image={item.image.url}
                                title={item.title}
                                link={`${isEn ? "/en" : ''}/blog/${meta?.slug}`}
                            />
                        );
                    })}
                </div>
                {pagination?.pageCount > 1 && (
                <div className="mt-[40px]">
                    <Pagination 
                    currentPage={currentPage}
                    pageCount={pagination.pageCount}
                    onPageChange={handlePageChange}
                    />
                </div>
                )}
            </div>
        </section>
    );
};

export default BlogContainer;